import { Checkbox } from "components/Atoms/inputs/Checkbox";
import CountryDropdown from "components/dropdowns/reactselect/CountryDropdown";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";

interface Props {
  value: server.dto.State[]
  onChanged: (selectedStates: server.dto.State[]) => void
}

const State = (props: Props) => {
  const [country, setCountry] = React.useState<server.dto.Country>(serverReference.countries.find(c => c.key === site.userPreference.regional.country));
  const selectedStates = new Set(props.value.map(state => state.key));

  const onStateChecked = (state: server.dto.State) => {
    if (selectedStates.has(state.key)) {
      props.onChanged(props.value.filter(s => s.key !== state.key));
    } else {
      props.onChanged([...props.value, state]);
    }
  };

  const onCountryChange = (country: server.dto.Country) => {
    setCountry(country);
    props.onChanged([]);
  };

  return <>
    <div className="margin-bottom">
      <CountryDropdown
        value={country}
        onChange={onCountryChange}
      />
    </div>

    <div className="multiple-columns">
      {country.states?.map(state => (
        <div key={state.key} className="margin-bottom-small">
          <Checkbox
            keyboardNavigationOptions={VerticalKeyboardNavigationGroup("state")}
            checked={selectedStates.has(state.key)}
            label={state.name ?? RESX.GeneralLabels.NotSpecified}
            onChange={() => { onStateChecked(state); }}
          />
        </div>
      ))}
    </div>
  </>;
};

export default State;